module.exports = __webpack_public_path__ + "img/wh.df4d93bd.webp";